import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, NO_ERRORS_SCHEMA } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BulkImportService } from '../../../shared/services/bulk-import.service';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';

import { CommonService } from '../shared/services/bulk-maintenance/common.service';
import { AppPaduService } from '../shared/services/bulk-maintenance/app-padu.service';
import { ExportDataService } from '../../../shared';
import { MatSort } from '@angular/material/sort';
import { BusinessSupportService } from '../shared/services/bulk-maintenance/business-support.service';
import { PrimaryUploadService } from '../shared/services/bulk-maintenance/primary-upload.service';
import { ModelEditService } from '../shared/services/bulk-maintenance/model-edit.service';
import { InitiativeService } from '../shared/services/bulk-maintenance/initiative.service';
import { Bulk_Fields } from '../../../constants/fields';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AppDemograhicService } from '../shared/services/bulk-maintenance/app-demographic.service';
import { AppHubService } from '../../application-hub/app-hub.service';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
import { MatIcon } from '@angular/material/icon';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DropdownWithSearchComponent } from '../../../shared/elements/dropdown-with-search/dropdown-with-search.component';
import { NgClass } from '@angular/common';
import { MaintenanceTableComponent } from '../../../shared/components/maintenance-table/maintenance-table.component';
import { LoaderComponent } from '../../../shared/elements/loader/loader.component';
@Component({
    selector: 'app-bulk-maintenance',
    templateUrl: './bulk-maintenance.component.html',
    styleUrls: ['./bulk-maintenance.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatIcon, RouterLink, MatGridList, MatGridTile, MatRadioGroup, FormsModule, MatRadioButton, DropdownWithSearchComponent, NgClass, MaintenanceTableComponent, LoaderComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class BulkMaintenanceComponent implements OnInit {
  Filepath: string = '';
  i_icon: string = '';
  icon_redirection: string = '';
  AppDemographics = environment.AppDemographicsBulkEditTemplate;
  AppPADUTemplate = environment.AppPADUTemplate;
  modalTitle: string;
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  fileAttr = 'Choose File';
  fileToUpload: File = null;
  showLoader: boolean = false;
  showtable: boolean = false;
  dataSourceDetails: MatTableDataSource<any>;
  userAccess: any;
  failedData: any[] = [];
  isDataLarge: boolean = false;
  isInitiativeSelected: boolean = false;
  initiativeList: Array<any> = [];
  selectedInitiative: any = null;
  initiativeReportLink: string;
  rowHeight: string = '60px';
  TABLE_CONFIG: any = {
    pageSize: 10,
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    FILTER_OPTIONS: {
      "Message": [],
      "Error Message": []
    }
  };
  TABLE_COLUMNS_PASS: any = Bulk_Fields.AppPadu_Roadmap_TABLE_COLUMNS_PASS;
  TABLE_COLUMNS_FAIL: any = Bulk_Fields.AppPadu_Roadmap_TABLE_COLUMNS_FAIL;
  EditAction = {
    key: 'isEdit',
    label: 'Action'
  };

  data = [];


  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit',
    Message: 'select',
    'Error Message': 'select'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  uploadTypes = [
    {
      label: 'App Demographics',
      value: 'LOB_Update'
    },
    {
      label: 'Application PADU and Road Map',
      value: 'Padu_Update'
    },
    {
      label: 'Capability Mapping',
      value: 'Capability_Mapping'
    },
    {
      label: 'Model Edit',
      value: 'Edit_Model'
    },

    {
      label: 'Primary Upload',
      value: 'primary_Update'
    }
  ];
  uploadType: any;
  uploadConfig = {
    Padu_Update: {
      filePath: this.AppPADUTemplate
    },
    Capability_Mapping: {
      filePath: 'assets/Capability_Mapping_Bulk_Edit_Template.xlsx'
    },
    Edit_Model: {
      filePath: 'assets/Model_Bulk_Edit_Template.xlsx'
    },
    Add_Model: {
      filePath: 'assets/Model_Bulk_Add_Template.xlsx'
    },
    LOB_Update: {
      filePath: this.AppDemographics
    },
    primary_Update: {
      filePath: 'assets/Primary Capability Bulk Edit Template.xlsx'
    },
    Padu_Save: {
      filePath: this.AppPADUTemplate
    }
  };

  i_icons_link = {
    Padu_Update: {
      i_icon: environment.docUrl + 'user-guide/application-padu-roadmap-bulk-edit/'
    },
    Capability_Mapping: {
      i_icon: environment.docUrl + 'user-guide/business-support-bulk-upload/'
    },
    Edit_Model: {
      i_icon: environment.docUrl + 'user-guide/model-bulk-upload/'
    },
    primary_Update: {
      i_icon: environment.docUrl + 'user-guide/primary-upload/'
    },
    Padu_Save: {
      i_icon: environment.docUrl + 'user-guide/application-padu-roadmap-bulk-edit/'
    },
    Add_Model: {
      i_icon: environment.docUrl + 'user-guide/model-bulk-upload/'
    },
    LOB_Update: {
      i_icon: environment.docUrl + 'user-guide/Application-Demographics-bulk-edit/'
    },
    initiative_update: {
      i_icon: environment.docUrl + 'user-guide/EICloud-BulkUpdate/'
    }
  };
  msId: string = null;
  currentUser: string = null;

  acccess = {
    hasAppEditorSecureGrpAccess: false,
    hasModelEditorSecureGrpAccess: false,
    hasAdminSecureGrpAccess: false
  };
  isWriteAccess: boolean;
  isAdminRole: boolean = false;
  dataSourceDetails_fail: MatTableDataSource<unknown>;
  dataSourceDetails_Pass: any;
  showPreview: boolean = false;
  submitPayload: any;
  uploadedData: any[];
  uploadedColumnNames: string[];
  missingColumns: string[] = [];
  successPayload: any[];
  initiativeColumns: any[];
  filteredData: any[] = [];
  activeFilters: { [key: string]: any[] } = {};
  userDtls: { cn: string; mail: string; givenName: string; sn: string; };

  constructor(
    private router: Router,
    public toaster: ToastrService,
    private importService: BulkImportService,
    private appDemoService: AppDemograhicService,
    private commomService: CommonService,
    private appPaduService: AppPaduService,
    private exportService: ExportDataService,
    private businessSupportService: BusinessSupportService,
    private primaryUploadService: PrimaryUploadService,
    private modelEditService: ModelEditService,
    private initiativeService: InitiativeService,
    private appHubService: AppHubService,
    private breakpointObserver: BreakpointObserver,
    private sharedAuthService: SharedAuthService) {
        const currentUser = sessionStorage.getItem('currentUser') || '';
        this.userDtls = {
            cn: this.sharedAuthService.getMsid(),
            mail: sessionStorage.getItem('loggedInUserEmail') || '',
            givenName: currentUser ? currentUser.trim().split(',')[1].trim() : '',
            sn: currentUser ? currentUser.trim().split(',')[0].trim() : '',
        }
     }

  ngOnInit() {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.initializeData();
      });
    } else {
      this.initializeData();
    }
  }

  initializeData() {
    this.initiativeReportLink = environment.initiativeReportLink;
    this.uploadType = 'LOB_Update';
    this.Filepath = this.uploadConfig[this.uploadType]['filePath'];
    this.icon_redirection = this.i_icons_link[this.uploadType]['i_icon'];
    this.msId = this.sharedAuthService.getMsid();
    this.currentUser = sessionStorage.getItem('currentUser').replace(/\s/g, '');
    this.isWriteAccess = this.sharedAuthService.checkAppEditorSGAccess();
    this.isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    const isModelEditor = this.sharedAuthService.checkModelEditorSGAccess();
    const isAdmin = this.sharedAuthService.checkForRoleAccess('Admin');
    this.userAccess = this.sharedAuthService.getTechAccessData();
    this.getAllInitiatives();
    this.acccess.hasAdminSecureGrpAccess = this.isAdminRole;
    this.acccess.hasAppEditorSecureGrpAccess = this.isWriteAccess;
    this.acccess.hasModelEditorSecureGrpAccess = isModelEditor;
    this.acccess.hasAdminSecureGrpAccess = this.isAdminRole;
    if (!isAdmin) {
      if (!this.acccess.hasAppEditorSecureGrpAccess && (this.acccess.hasModelEditorSecureGrpAccess )) {
        delete this.uploadConfig['Padu_Update'];
        delete this.uploadConfig['Capability_Mapping'];
        delete this.uploadConfig['LOB_Update'];
        delete this.uploadConfig['primary_Update'];
        this.uploadTypes = this.uploadTypes.filter(d => d.value === 'Edit_Model' || d.value === 'Add_Model');
      } else if (this.acccess.hasAppEditorSecureGrpAccess && (!this.acccess.hasModelEditorSecureGrpAccess )) {
        delete this.uploadConfig['Edit_Model'];
        delete this.uploadConfig['Add_Model'];
        this.uploadTypes = this.uploadTypes.filter(d => d.value !== 'Edit_Model' && d.value !== 'Add_Model');
      }
    }
    this.sortConfig.active = 'Message';
    this.sortConfig.direction = 'asc';
  }


  // Handle filter applied event
  onFilterApplied(event: { columnKey: string, selectedValues: any[] }) {
    // chekk if activeFilters is not empty, if so empty the activeFilters object
    if (Object.keys(this.activeFilters).length != 0) {
      this.activeFilters = {};
    }
    this.activeFilters[event.columnKey] = event.selectedValues;
    this.applyFilters();
  }

  // Handle filter cleared event
  onFilterCleared(columnKey: string) {
    delete this.activeFilters[columnKey];
    this.applyFilters();
  }


  applyFilters() {
    const filtered = this.failedData.filter(row => {
      return Object.keys(this.activeFilters).every(columnKey => {
        if (!this.activeFilters[columnKey] || this.activeFilters[columnKey].length === 0) {
          return true;
        }

        if ((columnKey == 'Message' || columnKey == 'Error Message') && row[columnKey]) {
          const rowMessages = row[columnKey]?.split(',').map(message => message.trim()) || [];
          return this.activeFilters[columnKey].some(filter => rowMessages.includes(filter));
        }

        return this.activeFilters[columnKey].includes(row[columnKey]);
      });
    });

    this.dataSourceDetails_fail = new MatTableDataSource(filtered);
  }

  setRowHeight() {
    if (this.isInitiativeSelected) {
      this.detectBreakpoint();
    }
    else
      this.rowHeight = '60px';
  }
  detectBreakpoint() {
    this.rowHeight = '85px';
    this.breakpointObserver.observe(['(min-width: 1260px) and (max-width: 1515px)']).subscribe(result => {
      if (result.matches) this.rowHeight = '85px';
    });
    this.breakpointObserver.observe(['(min-width: 1516px) and (max-width: 1899px)']).subscribe(result => {
      if (result.matches) this.rowHeight = '90px';
    });
    this.breakpointObserver.observe(['(min-width: 1900px)']).subscribe(result => {
      if (result.matches) this.rowHeight = '100px';
    });
  }
  uploadTypeChange(e) {
    console.log(e.value);
    this.isInitiativeSelected = e.value == "initiative_update";
    this.setRowHeight();
    if (!this.isInitiativeSelected) {
      this.Filepath = this.uploadConfig[e.value]['filePath'];
      this.selectedInitiative = null;
    }
    this.icon_redirection = this.i_icons_link[e.value]['i_icon'];
    this.fileToUpload = null;
    this.fileInput.nativeElement.value = '';
    this.showtable = false;
    this.showPreview = false;
    this.missingColumns = [];
    this.isDataLarge = false;
  }

  uploadFileEvt(files: FileList) {
    if (files && files.length) {
      this.isDataLarge = false;
      //if(this.showtable) {this.showtable = !this.showtable;}
      this.showtable = !this.showtable;
      this.fileToUpload = files.item(0);
      // const data = this.commomService.convertCsvToArray(this.fileToUpload);
      // console.log(data);
      this.commomService.convertCsvToArray(this.fileToUpload).then(data => {
        this.uploadedData = data.excelRows;
        this.uploadedColumnNames = data.headers;
      });
      this.successPayload = [];
      this.failedData = [];
      this.initiativeColumns = [];

      this.showtable = false;
      this.showPreview = true;
    } else {
      this.fileToUpload = null;
    }
  }

  cancelUpload() {
    this.fileToUpload = null;
    this.fileInput.nativeElement.value = '';
    this.showtable = false;
    this.showPreview = false;
    this.missingColumns = [];
    this.isDataLarge = false;
  }

  navigateHomePage() {
    this.router.navigate([{ outlets: { primary: 'landing-page' } }]);
  }

  /**
   * @description: Handle export of failed data
   */
  private handleExportData(): void {
    if (this.failedData.length > 0) {
      this.exportAppData();
    }
  }

  /**
   * @description: Validate and process upload data based on upload type
   */
  private validateUploadData(): boolean {
    const validationConfig = {
      'Padu_Update': () => this.validatePaduUpdate(),
      'LOB_Update': () => this.validateLobUpdate(),
      'Capability_Mapping': () => this.validateCapabilityMapping(),
      'primary_Update': () => this.validatePrimaryUpdate(),
      'Edit_Model': () => this.validateEditModel()
    };
    const validator = validationConfig[this.uploadType];
    return validator ? validator() : true;
  }

  /**
   * @description: Validate Padu Update data
   */
  private validatePaduUpdate(): boolean {
    const appPaduAllFields = this.commomService.appPaduAllFields();
    this.uploadedColumnNames = this.commomService.modifyHeaders(this.uploadedColumnNames, appPaduAllFields);
    this.uploadedData = this.commomService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
    this.missingColumns = this.commomService.checkRequiredHeaders(this.uploadedColumnNames, appPaduAllFields);
    if (this.uploadedData.length > 2000) this.isDataLarge = true;
    return this.missingColumns.length === 0 && !this.isDataLarge;
  }

  /**
   * @description: Validate LOB Update data
   */
  private validateLobUpdate(): boolean {
    const appdemoAllFields = this.commomService.appdemoAllFields();
    this.uploadedColumnNames = this.commomService.modifyHeaders(this.uploadedColumnNames, appdemoAllFields);
    this.uploadedData = this.commomService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
    this.missingColumns = this.commomService.checkRequiredHeaders(this.uploadedColumnNames, appdemoAllFields);
    if (this.uploadedData.length > 2000) this.isDataLarge = true;
    return this.missingColumns.length === 0 && !this.isDataLarge;
  }

  /**
   * @description: Validate Capability Mapping data
   */
  private validateCapabilityMapping(): boolean {
    const checkingHeaders = this.businessSupportService.getRequiredHeaders();
    this.uploadedColumnNames = this.commomService.modifyHeaders(this.uploadedColumnNames, checkingHeaders);
    this.uploadedData = this.commomService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
    this.missingColumns = this.commomService.checkRequiredHeaders(this.uploadedColumnNames, checkingHeaders);
    if (this.uploadedData.length > 2000) this.isDataLarge = true;
    return this.missingColumns.length === 0 && !this.isDataLarge;
  }

  /**
   * @description: Validate Primary Update data
   */
  private validatePrimaryUpdate(): boolean {
    const primaryUploadRequiredHeaders = this.commomService.getPrimaryUploadRequiredHeaders();
    this.uploadedColumnNames = this.commomService.modifyHeaders(this.uploadedColumnNames, primaryUploadRequiredHeaders);
    this.uploadedData = this.commomService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
    this.missingColumns = this.commomService.checkRequiredHeaders(this.uploadedColumnNames, primaryUploadRequiredHeaders);
    if (this.uploadedData.length > 2000) this.isDataLarge = true;
    return this.missingColumns.length === 0 && !this.isDataLarge;
  }

  /**
   * @description: Validate Edit Model data
   */
  private validateEditModel(): boolean {
    const modelEditRequiredHeaders = this.commomService.modeleditRequiredFields();
    this.uploadedColumnNames = this.commomService.modifyHeaders(this.uploadedColumnNames, modelEditRequiredHeaders);
    this.uploadedData = this.commomService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
    this.missingColumns = this.commomService.checkRequiredHeaders(this.uploadedColumnNames, modelEditRequiredHeaders);
    if (this.uploadedData.length > 2000) this.isDataLarge = true;
    return this.missingColumns.length === 0 && !this.isDataLarge;
  }

  /**
   * @description: Reset form state after validation failure
   */
  private resetFormAfterValidationFailure(): void {
    this.showLoader = false;
    this.showtable = false;
    this.showPreview = false;
    this.fileToUpload = null;
    this.fileInput.nativeElement.value = '';
  }


  /**
   * @description: Update upload type for save operations
   */
  private updateUploadTypeForSave(): void {
    const saveTypeMapping = {
      'Padu_Update': 'Padu_Save',
      'primary_Update': 'primary_Save',
      'LOB_Update': 'LOB_Save',
      'Capability_Mapping': 'Capability_Mapping_Save',
      'Edit_Model': 'Model_Save',
      'initiative_update': 'initiative_save'
    };

    if (saveTypeMapping[this.uploadType]) {
      this.uploadType = saveTypeMapping[this.uploadType];
    }
  }

  /**
   * @description: Create form data for file upload
   */
  private createFormData(): FormData {
    const formData: FormData = new FormData();
    formData.append('cmi_file', this.fileToUpload, this.fileToUpload.name);
    formData.append('User_msid', this.sharedAuthService.getMsid());
    formData.append('User_email', sessionStorage.getItem('loggedInUserEmail'));
    formData.append('Action_Type', this.uploadType);

    let role: any = '';
    let lob: any = [];
    let sublob: any = [];

    if (this.userAccess) {
      role = this.userAccess.Role;
      lob = this.userAccess.lobId;
      sublob = this.userAccess.subLobId;
    }

    formData.append('User_Access', role);
    formData.append('lobId', lob);
    formData.append('subLobId', sublob);
    formData.append('isAdminRole', 'true');

    return formData;
  }

  /**
   * @description: Create payload for API requests
   */
  private createPayload(): any {
    let role: any = '';
    let lob: any = [];
    let sublob: any = [];

    if (this.userAccess) {
      role = this.userAccess.Role;
      lob = this.userAccess.lobId;
      sublob = this.userAccess.subLobId;
    }

    return {
      User_msid: this.sharedAuthService.getMsid(),
      User_email: sessionStorage.getItem('loggedInUserEmail'),
      Secure_Groups: sessionStorage.getItem('secureGroups'),
      Action_Type: this.uploadType,
      User_Access: role,
      lobId: lob,
      subLobId: sublob,
      isAdminRole: 'true'
    };
  }

  /**
   * @description: Process Padu Save operation
   */
  private processPaduSave(payload: any): void {
    this.submitPayload = {
      data: this.successPayload,
      payload: payload
    };
    console.log(this.submitPayload);

    this.appPaduService.submitAppPaduData(this.submitPayload, 'Padu_Save').subscribe(
      data => {
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
        this.showtable = false;
        this.uploadType = 'Padu_Update';
        this.showLoader = false;
        if (data['error'] == undefined) {
          this.toaster.success(
            'Thank you for submitting the request. You will be notified via email on status',
            '',
            { positionClass: 'toast-top-center', timeOut: 2000 }
          );
        }
        if (data['error']) {
          this.showLoader = false;
          this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
        }
      },
      error => {
        console.error(error);
        this.showLoader = false;
        this.toaster.error('Something went wrong, Please try again later.', '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    );
  }

  /**
   * @description: Process Padu Update operation
   */
  private processPaduUpdate(payload: any): void {
    let { successRecords, duplicateRecords, errorRec } = this.appPaduService.validateAppPaduData(this.uploadedData);
    this.uploadedData.map(x => {
      x['Non-Integrated Tech'] = x['Non Integrated Tech'];
      delete x['Non Integrated Tech'];
    });
    this.submitPayload = {
      data: successRecords,
      payload: payload
    };
    if (successRecords.length > 0) {
      this.appPaduService.submitAppPaduData(this.submitPayload, 'Padu_Update').subscribe(
        data => {
          console.log(data);
          if (data['FileData'] && data['FileData'].length > 0) {
            const passdata = [],
              faildata = [];
            for (let i = 0; i < data['FileData'].length; i++) {
              if (data['FileData'][i].Status.toLowerCase() == 'success') passdata.push(data['FileData'][i]);
              if (data['FileData'][i].Status.toLowerCase() == 'fail') faildata.push(data['FileData'][i]);
            }
            faildata.push(...duplicateRecords, ...errorRec);
            this.TABLE_COLUMNS_PASS = Bulk_Fields.AppPadu_Roadmap_TABLE_COLUMNS_PASS;
            this.TABLE_COLUMNS_FAIL = Bulk_Fields.AppPadu_Roadmap_TABLE_COLUMNS_FAIL;
            this.successPayload = passdata;

            const allErrors = faildata.flatMap(row => row['Error Message']?.split(',').map(error => error.trim()) || []);
            const uniqueErrors = Array.from(new Set(allErrors));
            const finalError = uniqueErrors.map(error => ({ key: error, value: error }));
            this.TABLE_CONFIG.FILTER_OPTIONS['Error Message'] = finalError;

            this.dataSourceDetails_fail = new MatTableDataSource(faildata);
            this.dataSourceDetails_fail.sort = this.sort;
            this.dataSourceDetails_Pass = new MatTableDataSource(passdata);
            this.failedData = faildata;
            console.log('Failed: ', this.failedData);

            this.TABLE_CONFIG['TABLE_CLASS'] = 'org-maintenance-tble-container';
            this.TABLE_CONFIG.totalItems =
              data['FileData'] && data['FileData'].length ? data['FileData'].length : 0;
            this.showtable = true;
            this.showPreview = false;
            this.showLoader = false;
          } else {
            this.toaster.error('Something went wrong, Please try again later.', '', {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
          }
        }
      );
    }
    else {
      const faildata = [...duplicateRecords, ...errorRec];
      this.setupTableData([], faildata, Bulk_Fields.AppPadu_Roadmap_TABLE_COLUMNS_PASS, Bulk_Fields.AppPadu_Roadmap_TABLE_COLUMNS_FAIL);
      console.log('Failed: ', faildata);
      this.showLoader = false;
    }

  }

  /**
   * @description: Setup table data with error filtering
   */
  private setupTableData(passdata: any[], faildata: any[], tableColumnsPass: any, tableColumnsFail: any, errorField: string = 'Message'): void {
    this.TABLE_COLUMNS_PASS = tableColumnsPass;
    this.TABLE_COLUMNS_FAIL = tableColumnsFail;

    const allErrors = faildata.flatMap(row => row[errorField]?.split(',').map(error => error.trim()) || []);
    const uniqueErrors = Array.from(new Set(allErrors));
    const finalError = uniqueErrors.map(error => ({ key: error, value: error }));
    this.TABLE_CONFIG.FILTER_OPTIONS[errorField] = finalError;

    this.dataSourceDetails_fail = new MatTableDataSource(faildata);
    this.dataSourceDetails_fail.sort = this.sort;
    this.dataSourceDetails_Pass = new MatTableDataSource(passdata);
    this.failedData = faildata;
    this.successPayload = passdata;

    this.TABLE_CONFIG['TABLE_CLASS'] = 'org-maintenance-tble-container';
    this.TABLE_CONFIG.totalItems = passdata.length + faildata.length;
    this.showtable = true;
    this.showPreview = false;
  }

  /**
   * @description: Process Capability Mapping Save operation
   */
  private processCapabilityMappingSave(payload: any): void {
    this.submitPayload['payload'] = payload;
    this.submitPayload['userDetails'] = this.userDtls;
    this.businessSupportService.submitBusinessMapping(this.submitPayload).subscribe(
      data => {
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
        this.showtable = false;
        this.uploadType = 'Capability_Mapping';
        this.showLoader = false;

        if (data['error'] == undefined) {
          this.toaster.success(
            'Thank you for submitting the request. You will be notified via email on status',
            '',
            { positionClass: 'toast-top-center', timeOut: 2000 }
          );
        }
        if (data['error']) {
          this.showLoader = false;
          this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  /**
   * @description: Process Capability Mapping operation
   */
  private processCapabilityMapping(formData: FormData): void {
    let finalErrorRecords = [];
    let finalSuccessRecords = [];
    const { validaterecords, duplicateRecords } = this.businessSupportService.validateRecordService(
      this.uploadedData,
      this.isAdminRole,
    );
    let successRec = validaterecords.filter((item: any) => (item.Status && item.Status.toLowerCase()) == 'success');
    let errorRec = validaterecords.filter((item: any) => (item.Status && item.Status.toLowerCase()) == 'fail');

    if (successRec.length > 0) {
      this.businessSupportService
        .capabilityMappingPreview({ validaterecords: successRec, userDetails: this.userDtls })
        .subscribe(
          accessValidatedRecords => {
            console.log(accessValidatedRecords);
            const successRecords = accessValidatedRecords['success'];
            const successRec = successRecords.map(x => x.excelRecord);
            this.showLoader = false;

            if (accessValidatedRecords['error'] && accessValidatedRecords['error'].length > 0) {
              const errors = accessValidatedRecords['error'].map(x => x.excelRecord);
              finalErrorRecords = [...errors, ...duplicateRecords, ...errorRec]; 
            }

            finalSuccessRecords = successRec;
            const finalDataSet = [...finalSuccessRecords, ...finalErrorRecords];
            const FileData = finalDataSet;

            if (FileData.length > 0) {
              const passdata = [],
                faildata = [];

              for (let i = 0; i < FileData.length; i++) {
                if(!FileData[i].Status){
                  console.log('Status is missing for record: ', FileData[i]);
                }
                if (FileData[i].Status.toLowerCase() == 'success') passdata.push(FileData[i]);
                if (FileData[i].Status.toLowerCase() == 'fail') faildata.push(FileData[i]);
              }

              this.setupTableData(passdata, faildata, Bulk_Fields.Capability_Mapping_TABLE_COLUMNS_PASS, Bulk_Fields.Capability_Mapping_TABLE_COLUMNS_FAIL);
              this.submitPayload = { capIdValidatedRecords: accessValidatedRecords['success'] };
              this.submitPayload['payload'] = formData;
            }
          },
          error => {
            console.error(error);
            this.showLoader = false;
            this.toaster.error('Something went wrong, Please try again later.', '', {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
          }
        );
    }
    else {
      finalErrorRecords = [...duplicateRecords, ...errorRec];
      this.setupTableData([], finalErrorRecords, Bulk_Fields.Primary_Upload_TABLE_COLUMNS_PASS, Bulk_Fields.Primary_Upload_TABLE_COLUMNS_FAIL);
      console.log('Failed: ', this.failedData);
      this.showLoader = false;
    }
  }

  /**
   * @description: Process Primary Save operation
   */
  private processPrimarySave(payload: any): void {
    this.submitPayload['payload'] = payload;
    this.submitPayload['userDetails'] = this.userDtls;
    this.primaryUploadService.primaryUploadSubmit(this.submitPayload).subscribe(
      data => {
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
        this.showtable = false;
        this.uploadType = 'primary_Update';
        this.showLoader = false;

        if (data['error'] == undefined) {
          this.toaster.success(
            'Thank you for submitting the request. You will be notified via email on status',
            '',
            { positionClass: 'toast-top-center', timeOut: 2000 }
          );
        }
        if (data['error']) {
          this.showLoader = false;
          this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  /**
   * @description: Process Primary Update operation
   */
  private processPrimaryUpdate(formData: FormData): void {
    console.log(this.uploadedData);

    let finalErrorRecords = [];
    let finalSuccessRecords = [];
    const [uniqueRecords, duplicates] = this.primaryUploadService.validateRecordService(this.uploadedData);
    let successRec = uniqueRecords.filter((item: any) => (item.Status && item.Status.toLowerCase()) == 'success');
    let errorRec = uniqueRecords.filter((item: any) => (item.Status && item.Status.toLowerCase()) == 'fail');
    if (successRec.length > 0) {
      this.primaryUploadService.primaryUploadPreview({ validaterecords: successRec }).subscribe(
        accessValidatedRecords => {
          console.log(accessValidatedRecords);
          const successRec = accessValidatedRecords.filter((item: any) => item.Status == 'Success');
          this.showLoader = false;

          const errors = accessValidatedRecords.filter((item: any) => item.Status == 'Fail');
          if (errors.length > 0) {
            finalErrorRecords = finalErrorRecords.concat(errors);
          }
          finalSuccessRecords = successRec;

          const finalDataSet = [...finalSuccessRecords, ...finalErrorRecords, ...duplicates, ...errorRec];
          const FileData = finalDataSet;

          if (FileData.length > 0) {
            const passdata = [],
              faildata = [];

            for (let i = 0; i < FileData.length; i++) {
              if (FileData[i].Status.toLowerCase() == 'success') passdata.push(FileData[i]);
              if (FileData[i].Status.toLowerCase() == 'fail') faildata.push(FileData[i]);
            }

            this.setupTableData(passdata, faildata, Bulk_Fields.Primary_Upload_TABLE_COLUMNS_PASS, Bulk_Fields.Primary_Upload_TABLE_COLUMNS_FAIL);
            this.submitPayload = { excelValidatedRecords: successRec };
            this.submitPayload['payload'] = formData;
          }
        },
        error => {
          console.error(error);
          this.showLoader = false;
          this.toaster.error('Something went wrong, Please try again later.', '', {
            positionClass: 'toast-top-center',
            timeOut: 1000
          });
        }
      );
    } else {
      finalErrorRecords = [...duplicates, ...errorRec];
      this.setupTableData([], finalErrorRecords, Bulk_Fields.Primary_Upload_TABLE_COLUMNS_PASS, Bulk_Fields.Primary_Upload_TABLE_COLUMNS_FAIL);
      console.log('Failed: ', this.failedData);
      this.showLoader = false;
    }
  }

  /**
   * @description: Process Model Save operation
   */
  private processModelSave(payload: any): void {
    this.submitPayload['payload'] = payload;
    this.modelEditService.submitModelEdit(this.submitPayload).subscribe(
      data => {
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
        this.showtable = false;
        this.uploadType = 'Edit_Model';
        this.showLoader = false;

        if (data['error'] == undefined) {
          this.toaster.success(
            'Thank you for submitting the request. You will be notified via email on status',
            '',
            { positionClass: 'toast-top-center', timeOut: 2000 }
          );
        }
        if (data['error']) {
          this.showLoader = false;
          this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  /**
   * @description: Process Edit Model operation
   */
  private processEditModel(formData: FormData): void {
    console.log(this.uploadedData);

    let finalErrorRecords = [];
    let finalSuccessRecords = [];
    const { uniques, duplicates } = this.modelEditService.validateRecord(this.uploadedData);
    let successRec = uniques.filter((item: any) => (item.Status && item.Status.toLowerCase()) == 'success');
    let errorRec = uniques.filter((item: any) => (item.Status && item.Status.toLowerCase()) == 'fail');
    if (successRec.length > 0) {
      this.modelEditService.modelEditPreview({ validaterecords: successRec, isModelEditor: this.acccess.hasModelEditorSecureGrpAccess}).subscribe(
        accessValidatedRecords => {
          console.log(accessValidatedRecords);

          const successRec = accessValidatedRecords['successRecord'];
          this.showLoader = false;

          const errors = accessValidatedRecords['errorData'];
          if (errors.length > 0) {
            finalErrorRecords = finalErrorRecords.concat(errors);
          }

          finalSuccessRecords = successRec;
          const finalDataSet = [...finalSuccessRecords, ...finalErrorRecords, ...duplicates, ...errorRec];
          const FileData = finalDataSet;

          if (FileData.length > 0) {
            const passdata = [],
              faildata = [];

            for (let i = 0; i < FileData.length; i++) {
              if (FileData[i].Status.toLowerCase() == 'success') passdata.push(FileData[i]);
              if (FileData[i].Status.toLowerCase() == 'fail') faildata.push(FileData[i]);
            }

            this.setupTableData(passdata, faildata, Bulk_Fields.Model_Edit_TABLE_COLUMNS_PASS, Bulk_Fields.Model_Edit_TABLE_COLUMNS_FAIL);
            this.submitPayload = { excelValidatedRecords: accessValidatedRecords['successRecord'] };
            this.submitPayload['payload'] = formData;
          }
        },
        error => {
          console.error(error);
          this.showLoader = false;
          this.toaster.error('Something went wrong, Please try again later.', '', {
            positionClass: 'toast-top-center',
            timeOut: 1000
          });
        }
      );
    } else {
      finalErrorRecords = [...duplicates, ...errorRec];
      this.setupTableData([], finalErrorRecords, Bulk_Fields.Model_Edit_TABLE_COLUMNS_PASS, Bulk_Fields.Model_Edit_TABLE_COLUMNS_FAIL);
      console.log('Failed: ', this.failedData);
      this.showLoader = false;
    }
  }

  /**
   * @description: Process Initiative Save operation
   */
  private processInitiativeSave(payload: any): void {
    this.submitPayload['payload'] = payload;
    this.initiativeService.initiativeSubmit(this.submitPayload).subscribe(
      data => {
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
        this.showtable = false;
        this.uploadType = 'initiative_update';
        this.showLoader = false;

        if (data['error'] == undefined) {
          this.toaster.success(
            'Thank you for submitting the request. You will be notified via email on status',
            '',
            { positionClass: 'toast-top-center', timeOut: 2000 }
          );
        }
        if (data['error']) {
          this.showLoader = false;
          this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  /**
   * @description: Process LOB Save operation
   */
  private processLobSave(payload: any): void {
    this.submitPayload['payload'] = payload;
    console.log(this.submitPayload);
    this.appDemoService.submitLOBData(this.submitPayload).subscribe(
      data => {
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
        this.showtable = false;
        this.uploadType = 'LOB_Update';
        this.showLoader = false;
        if (data['error'] == undefined) {
          this.toaster.success(
            'Thank you for submitting the request. You will be notified via email on status',
            '',
            { positionClass: 'toast-top-center', timeOut: 2000 }
          );
        }
        if (data['error']) {
          this.showLoader = false;
          this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
        }
      },
      error => {
        console.error(error);
        this.showLoader = false;
        this.toaster.error('Something went wrong, Please try again later.', '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    );
  }

  /**
   * @description: Process Initiative Update operation
   */
  private processInitiativeUpdate(formData: FormData): void {
    const initiative = this.selectedInitiative.data;
    this.initiativeService.initiativeColumndetails(initiative['initiative_ID']).subscribe((data) => {
      const cValues = data['cValues'];
      this.initiativeColumns = cValues;
      const requiredColumns = [];
      const configurableTableColumns = [];
      requiredColumns.push('Update_Type(U)');
      const requiredEditableCols = [];
      requiredEditableCols.push('Update_Type(U)');
      for (const item of cValues) {
        if (item['Bulk_required'] == 'Yes') {
          requiredColumns.push(item['column_name']);
          if (item['Editable'] && item['Editable'].toLowerCase() == 'yes') {
            requiredEditableCols.push(item['column_name']);
          }
        }
        if (item['Bulk_required'] == 'Yes') {
          const columnData = {
            key: item['column_name'],
            labelKey: item['column_name'],
            label: item['column_name'],
            addNew: false,
            filter: false,
            search: '',
            searchValue: '',
            edit: true,
            validations: [{ 'required': false }],
            expand: item['column_name'] == 'Application ID' || item['column_name'] == 'LOB_ID' || item['column_name'] == 'SubLOB_ID' ? false : true
          };
          configurableTableColumns.push(columnData);
        }
      }

      this.addInitiativeTableColumns(configurableTableColumns);
      // Required Headers Validation and large data validation
      this.missingColumns = this.commomService.checkRequiredHeaders(this.uploadedColumnNames, requiredEditableCols);
      if (this.uploadedData.length > 2000) this.isDataLarge = true;
      if (this.missingColumns.length > 0 || this.isDataLarge) {
        this.resetFormAfterValidationFailure();
      } else {
        this.processInitiativeValidation(initiative, data, configurableTableColumns, formData, requiredColumns);
      }
    }, (error) => {
      console.error(error);
      this.showLoader = false;
      this.toaster.error("Something went wrong, Please try again later.", '', { positionClass: 'toast-top-center', timeOut: 1000, });
    });
  }

  /**
   * @description: Add standard columns to initiative table configuration
   */
  private addInitiativeTableColumns(configurableTableColumns: any[]): void {
    const status_column = {
      key: 'Status',
      labelKey: "Status",
      label: 'Status',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }]
    };
    const App_Life_Cycle_column = {
      key: 'App Lifecycle Status',
      labelKey: "App Lifecycle Status",
      label: 'App Lifecycle Status',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      expand: false
    };
    const message_column = {
      key: 'Message',
      labelKey: "Message",
      label: 'Error',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      expand: false
    };
    configurableTableColumns.push(status_column, App_Life_Cycle_column);
  }

  /**
   * @description: Process initiative validation and preview
   */
  private processInitiativeValidation(initiative: any, data: any, configurableTableColumns: any[], formData: FormData, requiredColumns: any[] = []): void {
    const { reqBody, errorRecords } = this.initiativeService.validateInitiative(this.uploadedData, this.initiativeColumns, data['initiationMaster'][0], requiredColumns);
    reqBody['initiative'] = initiative;
    reqBody['allColumns'] = this.initiativeColumns;

    if (reqBody['uniques'].length > 0) {
      this.initiativeService.initiativePreview(reqBody).subscribe(responseData => {
        const { totalSuccessRec, totalErrorRec } = responseData;
        const finalSuccessRecords = totalSuccessRec;
        const finalDataSet = [...finalSuccessRecords, ...totalErrorRec, ...errorRecords];
        const FileData = finalDataSet;

        if (FileData.length > 0) {
          const passdata = [], faildata = [];
          for (let i = 0; i < FileData.length; i++) {
            if (FileData[i].Status.toLowerCase() == 'success') passdata.push(FileData[i]);
            if (FileData[i].Status.toLowerCase() == 'fail') faildata.push(FileData[i]);
          }

          const configurableTableColumns_pass = [...configurableTableColumns];
          const configurableTableColumns_fail = [...configurableTableColumns];
          const message_column = {
            key: 'Message',
            labelKey: "Message",
            label: 'Error',
            addNew: false,
            filter: true,
            search: '',
            searchValue: '',
            edit: true,
            validations: [{ 'required': false }],
            expand: false
          };
          configurableTableColumns_fail.unshift(message_column);

          this.setupTableData(passdata, faildata, configurableTableColumns_pass, configurableTableColumns_fail);
          this.submitPayload = { excelValidatedRecords: finalSuccessRecords };
          this.submitPayload['payload'] = formData;
          this.submitPayload['initiative'] = initiative;
          this.submitPayload['primaryColumn'] = reqBody['primaryColumn'];
          this.showLoader = false;
        }
      }, (error) => {
        console.error(error);
        this.showLoader = false;
        this.toaster.error("Something went wrong, Please try again later.", '', { positionClass: 'toast-top-center', timeOut: 1000, });
      });
    } else {
      this.showLoader = false;
      // Handle empty uniques case
      const passdata = [], faildata = [];
      for (let i = 0; i < errorRecords.length; i++) {
        if (errorRecords[i].Status.toLowerCase() == 'fail') faildata.push(errorRecords[i]);
      }

      const configurableTableColumns_pass = [...configurableTableColumns];
      const configurableTableColumns_fail = [...configurableTableColumns];
      const message_column = {
        key: 'Message',
        labelKey: "Message",
        label: 'Error',
        addNew: false,
        filter: true,
        search: '',
        searchValue: '',
        edit: true,
        validations: [{ 'required': false }],
        expand: false
      };
      configurableTableColumns_fail.unshift(message_column);
      this.setupTableData(passdata, faildata, configurableTableColumns_pass, configurableTableColumns_fail);
    }
  }

  /**
   * @description: Process LOB Update operation
   */
  private processLobUpdate(formData: FormData): void {
    try {
      let {
        validaterecords,
        finalErrorRecords,
        finalSuccessRecords,
        TotalRecordsCount,
        duplicateRecords
      } = this.appDemoService.validateRecordService(this.uploadedData, this.msId, this.currentUser);
      finalErrorRecords = [...finalErrorRecords, ...duplicateRecords];
      if (validaterecords.length > 0) {
        this.appDemoService.checkAccessData({ validaterecords: validaterecords }).subscribe((accessValidatedRecords) => {
          this.processLobUpdateResponse(accessValidatedRecords, TotalRecordsCount, formData, finalErrorRecords, finalSuccessRecords);
        });
      } else {
        this.processLobUpdateNoValidRecords(validaterecords, TotalRecordsCount, formData, finalErrorRecords, finalSuccessRecords);
      }
    } catch (error) {
      console.error('Error processing LOB update:', error);
      this.showLoader = false;
      this.toaster.error('Something went wrong, Please try again later.', '', {
        positionClass: 'toast-top-center',
        timeOut: 1000
      });
    }
  }

  /**
   * @description: Process LOB Update successful response
   */
  private processLobUpdateResponse(accessValidatedRecords: any, TotalRecordsCount: any, formData: FormData, finalErrorRecords: any, finalSuccessRecords: any): void {
    this.showLoader = false;
    console.log('Success: ', accessValidatedRecords);
    const successRecords = accessValidatedRecords['success'];
    const successRec = successRecords.map((x) => x.excelRecord);

    if (accessValidatedRecords['error'] && accessValidatedRecords['error'].length > 0) {
      const errors = accessValidatedRecords['error'].map((x) => x.excelRecord);
      finalErrorRecords = [...finalErrorRecords, ...errors];
    }
    finalSuccessRecords = successRec;
    const finalDataSet = [...finalSuccessRecords, ...finalErrorRecords];
    const FileData = finalDataSet;

    if (FileData.length) {
      const passdata = [], faildata = [];

      for (let i = 0; i < FileData.length; i++) {
        if (FileData[i].Status.toLowerCase() == 'success') passdata.push(FileData[i]);
        if (FileData[i].Status.toLowerCase() == 'fail') faildata.push(FileData[i]);
      }

      this.setupTableData(passdata, faildata, Bulk_Fields.App_Demographics_TABLE_COLUMNS_PASS, Bulk_Fields.App_Demographics_TABLE_COLUMNS_FAIL);
      this.submitPayload = { accessValidatedRecords: accessValidatedRecords['success'], failedCount: this.failedData.length, TotalRecordsCount };
      this.submitPayload['payload'] = formData;
    }
  }

  /**
   * @description: Process LOB Update with no valid records
   */
  private processLobUpdateNoValidRecords(validaterecords: any, TotalRecordsCount: any, formData: FormData, finalErrorRecords: any, finalSuccessRecords: any): void {
    console.log('here in else...');
    const finalDataSet = [...finalSuccessRecords, ...finalErrorRecords];
    const FileData = finalDataSet;

    if (FileData.length) {
      const passdata = [],
        faildata = [];

      for (let i = 0; i < FileData.length; i++) {
        if (FileData[i].Status.toLowerCase() == 'success') passdata.push(FileData[i]);
        if (FileData[i].Status.toLowerCase() == 'fail') faildata.push(FileData[i]);
      }

      this.setupTableData(passdata, faildata, Bulk_Fields.App_Demographics_TABLE_COLUMNS_PASS, Bulk_Fields.App_Demographics_TABLE_COLUMNS_FAIL);
      this.showLoader = false;
      this.submitPayload = {
        accessValidatedRecords: validaterecords['success'],
        validaterecords,
        TotalRecordsCount
      };
      this.submitPayload['payload'] = formData;
    }
  }

  submitForm(flag) {

    // Validate file format
    if (!this.commomService.validateFileFormat(this.fileToUpload)) {
      this.toaster.error('File format is not supported, Please try with excel files only.');
      return false;
    }

    // Handle export of failed data
    if (flag === true && this.failedData.length > 0) {
      this.handleExportData();
    }

    // Validate upload data based on type
    if (flag == false && !this.validateUploadData()) {
      this.resetFormAfterValidationFailure();
      return false;
    }



    // Update upload type for save operations
    if (flag == true) {
      this.updateUploadTypeForSave();
    }

    // Create form data and payload
    const formData: FormData = this.createFormData();
    const payload = this.createPayload();

    // Set loading state
    this.showLoader = true;
    this.showtable = false;

    // Process upload based on type
    this.processUploadByType(formData, payload);
  }

  /**
   * @description: Process upload based on type
   */
  private processUploadByType(formData: FormData, payload: any): void {
    const processingConfig = {
      'Padu_Save': () => this.processPaduSave(payload),
      'Padu_Update': () => this.processPaduUpdate(payload),// No validation available

      'Capability_Mapping_Save': () => this.processCapabilityMappingSave(payload),
      'Capability_Mapping': () => this.processCapabilityMapping(formData),//done

      'primary_Save': () => this.processPrimarySave(payload),
      'primary_Update': () => this.processPrimaryUpdate(formData),//done

      'Model_Save': () => this.processModelSave(payload),
      'Edit_Model': () => this.processEditModel(formData),//Done

      'initiative_save': () => this.processInitiativeSave(payload),
      'initiative_update': () => this.processInitiativeUpdate(formData),//done

      'LOB_Save': () => this.processLobSave(payload),
      'LOB_Update': () => this.processLobUpdate(formData) //done
    };

    const processor = processingConfig[this.uploadType];
    if (processor) {
      processor();
    }
  }

  showInfo() {
    window.open(environment.docUrl + 'user-guide/bulk-edit/');
  }

  exportAppData() {
    let name = 'Invalid Data';
    if (this.uploadType == 'Padu_Update') {
      name = 'Application PADU and RoadMap';
    }
    if (this.uploadType == 'LOB_Update') {
      name = 'App Demographics';
    }
    if (this.uploadType == 'primary_Update') {
      name = 'Primary Upload';
    }
    if (this.uploadType == 'Capability_Mapping') {
      name = 'Capability Mapping';
    }
    if (this.uploadType == 'Edit_Model') {
      name = 'Model Edit';
    }
    if (this.uploadType == 'initiative_update') {
      name = this.selectedInitiative.data['Initiative_Name'];
    }
    this.exportService.exportToExcel(name, [this.failedData]);
  }
  showRespectiveInfo() {
    window.open(this.icon_redirection);
  }

  setSelectedInitiative(initiative) {
    this.uploadType = 'initiative_update';
    this.selectedInitiative = initiative;
  }

  getAllInitiatives() {
    this.appHubService.getInitiativeAllList().subscribe((data: any) => {
      if (data && data.length > 0) {
        const isUserAdmin = this.sharedAuthService.checkAdminSGAccess();
        const AppEditor_AllRoles = this.sharedAuthService.getAppEditorAllRoles();

        const enabledInitiativeList: Array<any> = data.filter((val) => {
          if (val.Enabled == "Yes") {
            val.name = val.Initiative_Name;
            const fullAccessRole = val.Full_Access_Role.split(',');
            const lobAccessRole = val.LOB_Access_Role.split(',');
            //check for Admin only
            if (fullAccessRole.indexOf('Admin') != -1 && isUserAdmin && this.sharedAuthService.checkForRoleAccess('Admin')) {
              return val;
            } else {
              let hasAccess: boolean = false;
              AppEditor_AllRoles.forEach((role) => {
                if (!hasAccess) {
                  if (fullAccessRole.indexOf(role) != -1 && this.sharedAuthService.checkForRoleAccess(role) && role != 'Admin') {
                    hasAccess = true;
                  } else if (lobAccessRole.indexOf(role) != -1 && this.sharedAuthService.checkForRoleAccess(role) && role != 'Admin') {
                    hasAccess = true; //check for lob/sub lob based role
                  }
                }
              });
              if (hasAccess)
                return val;
            }

          }
        });
        if (enabledInitiativeList && enabledInitiativeList.length > 0) {
          this.addUploadType('Enterprise Initiatives', 'initiative_update');
          this.initiativeList = enabledInitiativeList;
        }
      }
    }, error => {
      console.error('error', error);
    });
  }

  addUploadType(label, val) {
    this.uploadTypes.push({
      label: label,
      value: val
    });
  }

}
